/*eslint-disable*/
import React from "react";
import {Link} from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

// @material-ui/icons
import {Dehaze} from "@material-ui/icons";
// core components
import CyberpunkDropdown from "components/CustomDropdown/CyberpunkDropdown.js";
import styles from "assets/jss/material-kit-react/components/headerLinksStyle.js";
import routes from "../routes.js";

const useStyles = makeStyles(styles);

export default function HeaderLinks(props) {
  const classes = useStyles();
  
  // Filter routes that should show in navigation
  const navRoutes = routes.filter(route => route.showInNav);
  
  return (
    <List className={classes.list}>
      <ListItem className={classes.listItem}>
        <CyberpunkDropdown
          noLiPadding
          buttonProps={{
            className: classes.navLink,
            color: "transparent"
          }}
          buttonIcon={Dehaze}
          dropdownList={navRoutes.map((route, index) => (
            <Link className={classes.dropdownLink} to={route.path} key={route.path}>
              <route.icon/> {route.navTitle}
            </Link>
          ))}
        />
      </ListItem>
    </List>
  );
}
